export class ItemBalance {
    ItemNumberAndLot: string
    Location: string
    ActiveDeliveryTicketValue: number
    AverageCost: number
    BeginningValue: number
    BookingQuantity: number
    CommittedQuantity: number
    InventoryValue: number
    ItemDescription: string
    ItemNumber: string
    MarketCost: number
    OnHandQuantity: number
    OnOrderQuantity: number
    OverstockPoint: number
    PositionDate: Date
    PositionDateTime: Date
    PositionQuantity: number
    PositionReport: string
    PrepaymentQuantity: number
    RecentCost: number
    ReorderPoint: number
    ReorderQuantity: number
    SubitemActive: string
    CreatedBy: string
    CreatedDate: Date
    LastUpdatedBy: string
    LastUpdatedDate: Date
    SQLID: string
    TenantID: string
    Quantity: number
    constructor() {

    }
}